<template>
    <div v-if="fineModel">
        <modal :showModal="showModal" :hideModal="closeModal">
            <h5 slot="header" class="align-self-center mb-0">Détails du pv : {{ fineModel.code }}</h5>

            <div slot="header-button" class="ml-4">
                <button class="btn-custom btn btn-sm" @click="openControlDetailsModal">
                    <i class="fas fa-search" title="Afficher les détails du contrôle"/>
                </button>
                <button class="btn-custom btn btn-sm" @click="openExportModal">
                    <i class="fas fa-share" title="Afficher les détails de la soumission à Tigre"/>
                </button>
                <button class="btn-custom btn btn-sm" @click="openHtmlModal">
                    <i class="fas fa-file" title="Afficher la vue HTML du PV"/>
                </button>
            </div>

            <div slot="body" class="w-100">

                <div class="row">
                    <div class="col-5"><b>Date :</b></div>
                    <div class="col-7">{{ fineModel.date }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Personne controlée :</b></div>
                    <div class="col-7">{{ fineModel.person }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Motif :</b></div>
                    <div class="col-7">{{ fineModel.reason }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Justificatif :</b></div>
                    <div class="col-7" v-html="getConcatJustificatif()"></div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Prix :</b></div>
                    <div class="col-7">{{ fineModel.price }} €</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Agent :</b></div>
                    <div class="col-7">{{ fineModel.officer }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Station de départ :</b></div>
                    <div class="col-7">{{ fineModel.station_start }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Lieu d'interpellation :</b></div>
                    <div class="col-7">{{ fineModel.station_end }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Véhicule :</b></div>
                    <div class="col-7">{{ fineModel.vehicle }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Type de véhicule :</b></div>
                    <div class="col-7">{{ fineModel.vehicleType }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Ligne :</b></div>
                    <div class="col-7">{{ fineModel.line }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Type de contrôle :</b></div>
                    <div class="col-7">{{ fineModel.controlType === 'moving' ? 'Embarqué' : 'Sol'}}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-5"><b>Type de tenue :</b></div>
                    <div class="col-7">{{ fineModel.outfit === 'uniform' ? 'Uniforme' : 'Civil'}}</div>
                </div>

                <template v-if="showOfficerObservation == 'true' || showPrivateOfficerObservation == 'true'">

                    <hr/>

                    <div class="row">
                        <div class="col-5"><b>Observation de l'agent :</b></div>
                        <div class="col-7 text-truncate cursor-pointer"
                             @click="swal('Observation de l\'agent', getConcatOfficerObservation())"
                        >
                            {{ getConcatOfficerObservation() }}
                        </div>
                    </div>

                </template>

                <template v-if="showPassengerObservation == 'true'">

                    <hr/>

                    <div class="row">
                        <div class="col-5"><b>Observation du passager :</b></div>
                        <div class="col-7 text-truncate cursor-pointer"
                             @click="swal('Observation du passager', fineModel.observationPassenger !== 'null' ? fineModel.observationPassenger : '-')"
                        >{{ fineModel.observationPassenger !== "null" ? fineModel.observationPassenger : '-' }}</div>
                    </div>

                </template>

                <div class="text-center my-3">

                    <button id="additionalInformationButton" class="btn btn-custom collapsed" type="button" data-toggle="collapse" data-target="#additionalInformation" aria-expanded="false" aria-controls="additionalInformation">
                        <i class="fas fa-angle-double-down open-icon"></i>
                        <i class="fas fa-angle-double-up close-icon"></i>
                    </button>

                </div>

                <div class="collapse" id="additionalInformation">

                    <div class="row">
                        <div class="col-8"><b>Date de création :</b></div>
                        <div class="col-4">{{ fineModel.createdAt }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Date de mise à jour :</b></div>
                        <div class="col-4">{{ fineModel.updatedAt }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Statut PV :</b></div>
                        <div class="col-4">{{ fineModel.exported }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Date dernière tentative export :</b></div>
                        <div class="col-4">{{ fineModel.exportDatetime }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Code de retour dernière tentative export :</b></div>
                        <div class="col-4">{{ fineModel.exportResult }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Message de retour dernière tentative export :</b></div>
                        <div class="col-4">{{ fineModel.exportResultMessage }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Statut image :</b></div>
                        <div class="col-4">{{ fineModel.exportedImage }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Date dernière tentative export image :</b></div>
                        <div class="col-4">{{ fineModel.exportImageDatetime }}</div>
                    </div>

                    <hr/>

                    <div class="row">
                        <div class="col-8"><b>Code de retour dernière tentative export image :</b></div>
                        <div class="col-4">{{ fineModel.exportImageResult }}</div>
                    </div>

                </div>

            </div>

            <div slot="footer">
                <button class="btn btn-danger" @click="closeModal">Fermer</button>
            </div>

        </modal>

        <control-details-modal
                :showModal="showControlDetailsModal"
                :closeModal="closeControlDetailsModal"
                :controlId="fineModel.control_id"
        ></control-details-modal>

        <fine-export-modal
                :showModal="showExportModal"
                :closeModal="closeExportModal"
                :fineId="fineId"
        ></fine-export-modal>

        <fine-html-modal
                :showModal="showHtmlModal"
                :closeModal="closeHtmlModal"
                :fineCode="fineModel.code"
        ></fine-html-modal>

    </div>

</template>

<script>
    import axios from "axios";
    import Swal from 'sweetalert2';
    import Modal from './Modal';
    import ControlDetailsModal from "./ControlDetailsModal";
    import FineExportModal from "./FineExportModal";
    import FineHtmlModal from "./FineHtmlModal";

    export default {
        name: 'fineDetailsModal',
        components: {Modal, ControlDetailsModal, FineHtmlModal, FineExportModal},
        props: {
            showModal: Boolean,
            openModal: Function,
            closeModal: Function,
            fineId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                fineModel: null,
                customerExportErrorLabelsByCode: {},
                showOfficerObservation: false,
                showPrivateOfficerObservation: false,
                showPassengerObservation: false,
                showControlDetailsModal: false,
                showExportModal: false,
                showHtmlModal: false
            }
        },
        created() {
            this.getCustomerExportErrorLabelsByCode();
            this.getFine(this.fineId);
            this.getShowOfficerObservation();
            this.getShowPrivateOfficerObservation();
            this.getShowPassengerObservation();
        },
        watch: {
            fineId: function (newVal, oldVal) {
                this.getFine(this.fineId);
            }
        },
        methods: {
            getCustomerExportErrorLabelsByCode() {
                axios.get('/api/parameters/value?key=web.infringementExporter.errorLabel').then(result => {this.customerExportErrorLabelsByCode = JSON.parse(result.data);});
            },

            getFine(fineId) {
                axios.get('/api/fines/' + fineId)
                    .then(result => {
                        this.fineModel = result.data;
                        this.fineModel = Object.assign({}, this.fineModel, {
                            exported: this.getExportStatus(result.data.exported),
                            exportDatetime: this.formatDate(result.data.exportDatetime),
                            exportResult: result.data.exportResult === 0 ? '-' : result.data.exportResult,
                            exportResultLabel: this.customerExportErrorLabelsByCode[result.data.exportResult],
                            exportedImage: this.getExportStatus(result.data.exportedImage),
                            exportImageDatetime: this.formatDate(result.data.exportImageDatetime),
                            exportImageResult: result.data.exportImageResult === 1 ? '-' : result.data.exportImageResult
                        });
                    });
            },

            getExportStatus(exportedValue) {
                if (exportedValue === null) {
                    return 'Non soumis';
                } else if (exportedValue === 0) {
                    return 'En erreur';
                } else if (exportedValue === 1) {
                    return 'Soumis';
                } else if (exportedValue === -1) {
                    return 'Ignoré';
                }
            },

            formatDate(date) {
                let formattedDate = null;
                if (date != null) {
                    const [ymd, hms] = date.split(' ');
                    const [year, month, day] = ymd.split("-");
                    formattedDate = day + '-' + month + '-' + year + ' ' + hms;
                }
                return formattedDate;
            },

            getShowOfficerObservation() {
                axios.get('/api/parameters/value?key=mobile.module.observationOfficer.visibility').then(result => {this.showOfficerObservation = result.data;});
            },

            getShowPrivateOfficerObservation() {
                axios.get('/api/parameters/value?key=mobile.module.privateObservationOfficer.visibility').then(result => {this.showPrivateOfficerObservation = result.data;});
            },

            getShowPassengerObservation() {
                axios.get('/api/parameters/value?key=mobile.module.observationPassenger.visibility').then(result => {this.showPassengerObservation = result.data;});
            },

            getConcatOfficerObservation() {
                let concatOfficerObservation = '';
                if (this.showOfficerObservation == 'true') {
                    concatOfficerObservation += this.fineModel.observationOfficer;
                }
                if (this.showPrivateOfficerObservation == 'true') {
                    concatOfficerObservation += ' ' + this.fineModel.privateObservationOfficer;
                }
                if (concatOfficerObservation.trim() === '' || concatOfficerObservation.trim() === 'null') concatOfficerObservation = '-';
                return concatOfficerObservation;
            },

            getConcatJustificatif() {
                let concat = this.fineModel.document;

                if (this.fineModel.delivery_date !== 'null') {
                    concat += '<br>'
                    concat += 'Date de remise : ' + this.fineModel.delivery_date;
                }

                if (this.fineModel.delivery_authority !== '') {
                    concat += '<br>'
                    concat += 'Autorité de remise : ' + this.fineModel.delivery_authority;
                }

                if (this.fineModel.delivery_num !== '') {
                    concat += '<br>'
                    concat += 'Numéro de remise : ' + this.fineModel.delivery_num;
                }

                return concat;
            },

            swal(title, text) {
                Swal(title, text);
            },

            openControlDetailsModal() {
                this.closeModal();
                this.showControlDetailsModal = true;
            },

            closeControlDetailsModal() {
                this.showControlDetailsModal = false;
                this.openModal(this.fineModel.id);
            },

            openHtmlModal() {
                this.closeModal();
                this.showHtmlModal = true;
            },

            closeHtmlModal() {
                this.showHtmlModal = false;
                this.openModal(this.fineModel.id);
            },

            openExportModal() {
                this.closeModal();
                this.showExportModal = true;
            },

            closeExportModal() {
                this.showExportModal = false;
                this.openModal(this.fineModel.id);
            }
        }
    }

</script>

<style>

    #additionalInformationButton {
        box-shadow: none !important;
    }

    #additionalInformationButton i {
        display: none !important;
    }

    #additionalInformationButton.collapsed .open-icon {
        display: inline-block !important;
    }

    #additionalInformationButton:not(.collapsed) .close-icon {
        display: inline-block !important;
    }

</style>


// WEBPACK FOOTER //
// resources/js/components/layout/FineDetailsModal.vue